import usePrivateAxios from '@/common/api/usePrivateAxios'
import { PaymentAdvanceData } from '@/features/paymentAdvances/types/paymentAdvance.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const usePaymentAdvance: (id: string) => UseQueryResult<PaymentAdvanceData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<{ data: { data: PaymentAdvanceData } }, unknown, PaymentAdvanceData>({
    queryKey: ['paymentAdvance', id],
    queryFn: () => privateAxios.get(`/billing/payment_advances/${id}`),
    enabled: !!id,
    select: (data) => {
      return data?.data?.data
    },
  })
}
